import { useState, useEffect } from 'react';

const STORAGE_KEY = 'nrtr-newsletter-shown';
const POPUP_DELAY = 5000; // 5 seconds

export const useNewsletterPopup = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if popup has been shown before
    const hasBeenShown = localStorage.getItem(STORAGE_KEY);
    
    if (!hasBeenShown) {
      // Show popup after delay
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, POPUP_DELAY);

      return () => clearTimeout(timer);
    }
  }, []);

  const hidePopup = () => {
    setIsVisible(false);
    // Mark as shown in localStorage
    localStorage.setItem(STORAGE_KEY, 'true');
  };

  const showPopup = () => {
    setIsVisible(true);
  };

  // Function to reset the popup (for testing purposes)
  const resetPopup = () => {
    localStorage.removeItem(STORAGE_KEY);
    setIsVisible(false);
  };

  return {
    isVisible,
    hidePopup,
    showPopup,
    resetPopup
  };
}; 